import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Table from "../../../components/Admin/Table";
import "../Projects/ProjectList.css";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchEmployeeList } from "../../../store/slices/employeeListSlice";
import {
  deleteEmployeeDetails,
  toggleEmployeeStatus,
} from "../../../services/employeeService";
import Spinner from "../../../components/Spinner/spinner";
import { appInsights } from "../../../AppInsights";

const EmployeeList = () => {
  const { userData } = useSelector((state) => state.user);
  const currentUserTypeId = localStorage.getItem("userTypeId");
  //Ref:to filter data in table
  const [list, setList] = useState(null);
  //Access State
  const { employeeList, employeeListLoading, error } = useSelector(
    (state) => state?.employeeList
  );
  const currentUserRoleId = userData?.userTypes?.find(
    (type) => type?.userTypeId == currentUserTypeId
  );

const roleId = currentUserRoleId?.userTypeRoleId
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [visible, setVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const toast = React.useRef(null);
  // Transform the data to match old structure
  const transformedData =
    list?.map((item) => ({
      ...item,
      name: item?.userName || "",
      projectType:
        item?.userProjects
          ?.map((up) => up?.projectType || "")
          ?.filter(Boolean)
          ?.join(" / ") || "",
      manager: item?.managerName || "",
      Location: item?.location || "",
      // Flatten all projects into a single array for searching
      allProjects:
        item?.userProjects?.reduce((acc, up) => {
          if (up?.projects && Array.isArray(up?.projects)) {
            acc.push(
              ...up?.projects?.map((p) => p?.name || "")?.filter(Boolean)
            );
          }
          return acc;
        }, []) || [],
      // Keep the structured projects for display
      Projects:
        item?.userProjects
          ?.filter((up) => up?.projects && Array.isArray(up?.projects))
          ?.map((up) => up?.projects)
          .flat()
          ?.map((p) => p?.name || "")
          ?.filter(Boolean) || [],
      userProjects: item?.userProjects || [],
      isActive: Boolean(item?.isActive),
    })) || [];

  const showProjectDialog = (rowData) => {
    if (!rowData?.userProjects || !Array.isArray(rowData?.userProjects)) {
      return;
    }
    // Check if there are any projects before showing dialog
    const hasProjects = rowData?.userProjects.some(
      (projectType) =>
        projectType?.projects &&
        Array.isArray(projectType?.projects) &&
        projectType?.projects?.length > 0
    );

    if (hasProjects) {
      setSelectedRowData(rowData);
      setVisible(true);
    }
  };
  const confirmApprove=(data,value)=>{
    confirmDialog({
      message: `Are you sure you want to ${value?'Enable':'Disable'} this Employee?`,
      header: "Employee Status!",
      icon: "pi pi-info-circle delete-state-icon1",
      className: "addPaddingForDialogBox",
      acceptClassName: "p-button-danger ",
      accept: () => handleStatusChange(data,value),
      reject: () => {},
    });
  }

  const renderDialog = () => {
    if (!selectedRowData) return null;

    let totalProjects = 0;
    // Calculate total projects across all project types
    selectedRowData.userProjects?.forEach((projectType) => {
      if (projectType?.projects && Array.isArray(projectType?.projects)) {
        totalProjects += projectType?.projects?.length;
      }
    });

    // If no projects at all, don't show dialog
    if (totalProjects === 0) return null;

    return (
      <Dialog
        visible={visible}
        onHide={() => setVisible(false)}
        className="w-11/12 sm:w-8 md:w-6 lg:w-6 mx-auto"
      >
        <div className="bg-white p-3 sm:p-0">
          {selectedRowData?.userProjects?.map((projectType, index) =>
            // Only render project types that have projects
            projectType?.projects &&
            Array.isArray(projectType?.projects) &&
            projectType?.projects?.length > 0 ? (
              <div key={index} className="mb-4">
                <h2 className="text-xl font-semibold mb-2">
                  {projectType?.projectType}
                </h2>
                <div className="pt-2 flex flex-wrap justify-start">
                  {projectType?.projects?.map((project) => (
                    <span
                      key={project?.projectId}
                      className="surface-ground border-round-2xl font-semibold text-blue-900 px-3 py-2 ml-2 mb-2"
                    >
                      {project?.name}
                    </span>
                  ))}
                </div>
              </div>
            ) : null
          )}
        </div>
      </Dialog>
    );
  };

  const columns = [
    {
      field: "name",
      header: "Employee",
      sortable: true,
      type: "subText",
      frozen:true
    },
    {
      field: "projectType",
      header: "Project Type",
      sortable: true,
    },
    {
      field: "Projects",
      header: "Projects",

      type: "counter",
      body: (rowData) => (
        <div
          className="cursor-pointer"
          onClick={() => showProjectDialog(rowData)}
        >
          {rowData?.Projects?.length}
        </div>
      ),
    },
    {
      field: "Location",
      header: "Location",
      sortable: true,
    },
    {
      field: "managerName",
      header: "Manager",
   
    },
  ];

  const handleDownload = (rowData) => {};

  const handleStatusChange = async (rowData, value) => {
    try {
      let result = await toggleEmployeeStatus(
        currentUserTypeId,
        value,
        rowData?.userId
      );
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: `${result?.message}`,
        life: 5000,
        closable: true,
      });
      fetchEmployeeDetails();
    } catch (error) {
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || `Something went wrong at Server Side`,
        life: 3000,
      });
    }
  };
  const handleView = (rowData, value) => {};

  const actions = {
    status: {
      label: "Status",
      enabled: true,
      onChange: confirmApprove,
    },
    menu: {
      label: " ",
      enabled: true,
      items: [
        {
          label: "Edit",
          icon: "pi pi-pencil",
          command: (e) =>  roleId==2?navigate(`/hr/employee/${e?.userId}`):navigate(`/admin/employee/${e?.userId}`),
        },
        {
          label: "Delete",
          icon: "pi pi-trash",
          command: (e) => confirmDelete(e),
        },
      ],
    },
    view: {
      label: "View",
      enabled: false,
      onClick: (rowData) => handleView(rowData),
    },
    download: {
      label: "Download",
      enabled: false,
      onClick: (rowData) => handleDownload(rowData),
    },
  };

  const confirmDelete = (rowData) => {
    confirmDialog({
      message: "Are you sure you want to Delete this Employee?",
      header: "Delete Employee!",
      icon: "pi pi-info-circle delete-state-icon1",
      className: "addPaddingForDialogBox",
      acceptClassName: "p-button-danger ",
      accept: () => handleDelete(rowData),
      reject: () => {},
    });
  };



  const handleDelete = async (rowData) => {
    try {
      let result = await deleteEmployeeDetails(
        JSON.parse(currentUserTypeId),
        rowData?.userId
      );
      toast?.current?.show({
        severity: "success",
        summary: "Successful",
        detail: `${result}`,
        life: 5000,
        closable: true,
      });

      await dispatch(fetchEmployeeList(currentUserTypeId));
    } catch (error) {
      appInsights.trackException("Delete EmployeeList", { exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
        life: 3000,
      });
    }
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <IconField iconPosition="left">
          <InputIcon
            id={"search-icon"}
            className={`pi pi-search pl-1 ${searchQuery ? "hidden" : ""}`}
          />
          <InputText
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="      Search Employee"
            className="w-100 search-field"
          />
        </IconField>
      </div>
    );
  };

  const tableStyle = {
    dataTable: "p-datatable-sm",
  };

  // Filter data based on search query
  const filteredData = !searchQuery
    ? transformedData
    : transformedData.filter((item) => {
        const searchTerm = searchQuery.toLowerCase().trim();

        // Handle active/inactive search
        if (searchTerm === "active") return item.isActive;
        if (searchTerm === "inactive") return !item.isActive;

        // Regular search on other fields
        return (
          item?.name?.toLowerCase()?.includes(searchTerm) ||
          item?.projectType?.toLowerCase()?.includes(searchTerm) ||
          item?.manager?.toLowerCase()?.includes(searchTerm) ||
          item?.Location?.toLowerCase()?.includes(searchTerm) ||
          // Search in all projects
          item?.allProjects?.some((projectName) =>
            projectName?.toLowerCase()?.includes(searchTerm)
          ) ||
          // Search in project types from userProjects
          item?.userProjects?.some((up) =>
            up?.projectType?.toLowerCase()?.includes(searchTerm)
          ) ||
          item?.email?.toLowerCase()?.includes(searchTerm)
        );
      });

  const fetchEmployeeDetails = async () => {
    if (employeeListLoading) return; // Don't make another API call if one is in progress
    try {
      // TODO: need to pass : userData?.userTypes[0]?.userTypeId
      await dispatch(fetchEmployeeList(currentUserTypeId));
    } catch (error) {
      appInsights.trackException("Get EmployeeList", { exception: error });
      //  TODO: add toast
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
        life: 3000,
      });
    }
  };

  useEffect(() => {
    if (!employeeListLoading && !employeeList) {
      fetchEmployeeDetails(); // Fetch data if projectData doesn't exist
    }
  }, [dispatch, employeeList]); // This will only run when projectData changes

  // Use another effect to watch projectData and log it when it changes
  useEffect(() => {
    if (employeeList) {
      setList(employeeList);
    }
  }, [employeeList]);

  return (
    <div className="timesheet-table-container p-3 border-round-xl bg-white">
      {renderDialog()}
      <div className="sm:flex justify-content-between px-1 align-items-center">
        <div className="flex align-items-center p-2 gap-2">
          <h2 className="employee_header font-bold m-0 pl-2 pr-3">
            Employee List
          </h2>
          {list && (
            <span className="count-span pl-3 pr-3 md:pl-4 md:pr-4 p-2">
              {" "}
              {list?.length}{" "}
            </span>
          )}
        </div>
        <div className="pl-3">
          <Button
            label="New Employee"
            icon="pi pi-plus"
            className="button-bg admin_add_btn"
            onClick={() => roleId==2?navigate(`/hr/employee/new`):navigate("/admin/employee/new")}
          />
        </div>
      </div>
      <div className="table-container surface-section p-3 border-round-xl ">
        {employeeListLoading && <Spinner />}
        <Toast ref={toast} position="top-center" />
        <ConfirmDialog className="adminRejectDialog projectRejectDialog"/>
        {!employeeListLoading && (
          <Table
            content={filteredData}
            columnsData={columns}
            actions={actions}
            tableStyle={tableStyle}
            header={renderHeader}
            paginator={true}
            rows={50}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyMessage="No employees found"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
          />
        )}
      </div>
    </div>
  );
};

export default EmployeeList;
